import React, { useCallback, useEffect, useMemo, useState } from 'react';

import { downloadExcel, downloadSettingExcel } from "src/utils/blob/blobUtil";

import { SysCodeDto } from 'src/dtos/code/sysCodeDto';

import { defaultMST3040_R01Filter, MST3040_R01Filter, useMST3040_R01Store } from 'src/containers/mes/MST/MST3040_R01/Store_MST3040_R01';
import useFetchActionbarAuth from 'src/hooks/useFetchActionbarAuth';
import { Tab } from 'src/store/useUiuxStore';
import { useLoadingSpinnerStore } from 'src/store/util/loadingSpinnerUtil';
import { showError, showSuccess, ShowSuccessFetch, showWarning } from 'src/utils/toast/toastUtil';

import { deleteMST3040_R01, downloadExcel_MST3040_R01, getMST3040_R01AllCount, getMST3040_R01DetailList, getMST3040_R01List, getMST3040_R01UsageList, getPdfBlob_MST3040_R01, patchMST3040_R01, postMST3040_R01 } from "./Api_MST3040_R01";
import { defaultMST3040_R01DetailDto, defaultMST3040_R01HeaderDto, defaultMST3040_R01UsageDto, MST3040_R01DetailDto, MST3040_R01Dto, MST3040_R01HeaderDto } from './Dto_MST3040_R01';
import { AgGridReact } from 'ag-grid-react';
import { fetchDataSetHandler, fetchFilterConfig, gridRefSelectedRowHandler, InsertRowHandler } from 'src/utils/grid/GridHandlerContent';
import { CompanyDto } from 'src/dtos/company/companyDto';
import { useCommonCodeStore } from 'src/store/useCommonCodeStore';
import { validateString } from 'src/utils/string/stringUtil';
import { useQzPrint } from 'src/hooks/useQzPrint';
import qz from 'qz-tray';
import { useCommonCodeValidate } from 'src/utils/commonCode/CommonCodeValidateContext';
import {
	buildCommonCodeRequirements,
	MST3040_R01_DETAIL_ROW_VALIDATE,
} from 'src/utils/commonCode/commonCodeRequirementConfig';

interface Props {
	gridRef: React.RefObject<AgGridReact<MST3040_R01HeaderDto> | null>;
	detailGridRef: React.RefObject<AgGridReact<MST3040_R01DetailDto> | null>;

	tabList: Tab[] | undefined;
	setMessage: (message: string) => void;

	containerRef: React.RefObject<HTMLDivElement | null>;
	isResizing: React.MutableRefObject<boolean>;
	
}



export const Content_MST3040_R01 = (props: Props) => {

	const {
		gridRef, detailGridRef,
		tabList, setMessage,
		containerRef,
		isResizing,
	} = props;

	const { layerList, compCdList, itemCdMap } = useCommonCodeStore();

	
	const {
		MST3040_R01Filter, setMST3040_R01Filter,
		MST3040_R01PastFilter, setMST3040_R01PastFilter,
		MST3040_R01List, setMST3040_R01List,
		editMST3040_R01, setEditMST3040_R01,
		selectedMST3040_R01, setSelectedMST3040_R01, 
		deletedMST3040_R01DetailList, setDeletedMST3040_R01DetailList, addDeletedMST3040_R01DetailList, removeDeletedMST3040_R01DetailList, 
		selectedMST3040_R01DetailList, setSelectedMST3040_R01DetailList, addSelectedMST3040_R01DetailList, removeSelectedMST3040_R01DetailList,
		MST3040_R01DetailList, setMST3040_R01DetailList, insertMST3040_R01DetailList,
		editMST3040_R01Detail, setEditMST3040_R01Detail,
		originalMST3040_R01DetailList, setOriginalMST3040_R01DetailList,
		MST3040_R01UsageList, setMST3040_R01UsageList, insertMST3040_R01UsageList, removeMST3040_R01UsageList, updateMST3040_R01UsageList,
		originalMST3040_R01UsageList, setOriginalMST3040_R01UsageList,
		selectedMST3040_R01Usage, setSelectedMST3040_R01Usage, initSelectedMST3040_R01Usage,
		allCount, setAllCount,
		initData,
		detailFetchTrigger, setDetailFetchTrigger,
		setScrollTop,
		setDetailScrollTop,
		setUsageScrollTop,
	} = useMST3040_R01Store();
	const { setLoadingSpinner } = useLoadingSpinnerStore();
	const { validateCommonCodeLists } = useCommonCodeValidate();
	const { printPdfFromBlob } = useQzPrint();

	useFetchActionbarAuth("MST3040_R01");

	const [clickable, setClickable] = useState(true);

	const handlePrintClick = useCallback(async () => {
		if (!selectedMST3040_R01 || !selectedMST3040_R01.prntItemcd) {
				showWarning("출력할 품목정보를 선택하세요.");
				setMessage("출력할 품목정보를 선택하세요.");
				return;
			}
			setLoadingSpinner(true);
			try {
				const blob = await getPdfBlob_MST3040_R01(selectedMST3040_R01.prntItemcd);
				if (qz.websocket.isActive()) {
					const ok = await printPdfFromBlob(blob, "report1");
					if (ok) {
						showSuccess("PDF 출력을 완료하였습니다.");
					} else {
						const fileURL = URL.createObjectURL(blob);
						window.open(fileURL, "_blank");
						setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
						// showWarning("QZ 출력 실패로 브라우저 미리보기로 대체합니다.");
					}
				} else {
					const fileURL = URL.createObjectURL(blob);
					window.open(fileURL, "_blank");
					setTimeout(() => URL.revokeObjectURL(fileURL), 5000);
					showSuccess("PDF를 새 탭에서 열었습니다.");
				}
			} catch (error) {
				setMessage("PDF 출력 중 오류가 발생했습니다.");
			} finally {
				setLoadingSpinner(false);
			}
	}, [selectedMST3040_R01, printPdfFromBlob, setLoadingSpinner, setMessage]);
	

	const handleExcelClick = useCallback(async () => {
		if (!selectedMST3040_R01) {
			showWarning("선택된 품목정보가 없습니다.");
			return;
		}
		setLoadingSpinner(true);

		const response = await downloadExcel_MST3040_R01('', selectedMST3040_R01.prntItemcd, MST3040_R01List.length ?? 0);

		downloadSettingExcel({ responseData: response.data.data, fileName: '실장좌표정보 등록-excel.xlsx' });

		setLoadingSpinner(false);
	}, [selectedMST3040_R01])

	const getParams = (filter: MST3040_R01Filter) => {
		const params: Partial<MST3040_R01Filter> = {
			brandCd: filter.brandCd || undefined,
			itemGroup: filter.itemGroup || undefined,
			prntItemcd: filter.prntItemcd || undefined,
		};
		return params;
	}

	const renewalAllCount = useCallback(async () => {
		const response = await getMST3040_R01AllCount(getParams(MST3040_R01Filter));
		setAllCount(response.data.data);
		return response.data.data;
	}, [MST3040_R01Filter, setAllCount]);

	const fetchData = useCallback(async () => {
		setLoadingSpinner(true);
		setScrollTop(null);
		setDetailScrollTop(null);
		setUsageScrollTop(null);
	
		const responseData = (await getMST3040_R01List(
			'search',
			getParams(MST3040_R01Filter),
			MST3040_R01List.length ?? 0
		));


		let newList = [...responseData.data.data ] as MST3040_R01HeaderDto[];
		setMST3040_R01List(newList);

		const processAllCount = await renewalAllCount();
		if (newList && newList.length > 0) {
			gridRefSelectedRowHandler(
				gridRef,
				setSelectedMST3040_R01,
				() => true,// () => !responseData.find(value => value.salBillNo === selectedMST3040_R01?.salBillNo)
			);
			setMST3040_R01PastFilter(MST3040_R01Filter);
			ShowSuccessFetch(setMessage, `조회가 완료되었습니다. (총 ${newList.length}/${processAllCount}건)`);
		}else {
			showWarning('데이터가 없습니다.');
			setSelectedMST3040_R01(undefined);
			setMST3040_R01List([]);
			setMST3040_R01DetailList([]); 
			setDeletedMST3040_R01DetailList([]);
			setSelectedMST3040_R01DetailList([]);
			setOriginalMST3040_R01DetailList([]);
		}
		setLoadingSpinner(false);
		return responseData;
	}, [MST3040_R01Filter, MST3040_R01List, setMST3040_R01List, setMST3040_R01PastFilter, setSelectedMST3040_R01, selectedMST3040_R01, setScrollTop, setDetailScrollTop, setUsageScrollTop])

	

	//신규 행 추가시 기본적으로 세팅할 데이터를 정하고 생성
	const defaultMST3040_R01DetailRow = useCallback(() => {
		const commonResult = validateCommonCodeLists(
			buildCommonCodeRequirements(MST3040_R01_DETAIL_ROW_VALIDATE, {
				layerList,
			}),
		);
		if (!commonResult.valid) {
			return { ...defaultMST3040_R01DetailDto };
		}

		return {
			...defaultMST3040_R01DetailDto,
			prntItemcd: selectedMST3040_R01?.prntItemcd || '',
			topBottom: layerList[0].minorCd,
			inserted: true,
		};
	}, [defaultMST3040_R01DetailDto, selectedMST3040_R01, layerList, validateCommonCodeLists]);

	const defaultMST3040_R01UsageRow = useCallback(() => {

		return {
			...defaultMST3040_R01UsageDto,
			inserted: true,
		}
	}, [defaultMST3040_R01DetailDto, selectedMST3040_R01]);
	
	
	const fetchDetailList = useCallback(async (prntItemcd: string) => {
		const responseData = (await getMST3040_R01DetailList(prntItemcd)).data.data;
		if(responseData && responseData.length > 0){
			setMST3040_R01DetailList(
				responseData.map((value: any, idx: any) => ({
					...value,
					valueIndex: value.valueIndex ?? idx + 1,
					orderIndex: value.orderIndex ?? idx + 1,
					orderIndexSeq: value.orderIndexSeq ?? 0,
				})
			));
			setOriginalMST3040_R01DetailList(responseData);
			setMessage(`${selectedMST3040_R01?.prntItemnm}의 실장좌표정보 ${responseData.length}건을 조회하였습니다.`);
			setTimeout(() => setMessage(""), 5000);
		}else{
			setMST3040_R01DetailList([]);
			// showWarning('해당 모품목코드의 자품목 목록이 없습니다.');
			// 행추가 안함
			// insertMST3040_R01DetailList([{ ...defaultMST3040_R01DetailRow, orderIndex: responseData.length + 1, orderIndexSeq: 0, inserted: true }]);
		}
	}, [selectedMST3040_R01, MST3040_R01DetailList])

	const fetchUsageList = useCallback(async (prntItemcd: string) => {
		const responseData = (await getMST3040_R01UsageList(prntItemcd)).data.data;
		if(responseData && responseData.length > 0){
			setMST3040_R01UsageList(
				responseData.map((value: any, idx: any) => ({
					...value,
					valueIndex: value.valueIndex ?? idx + 1,
					orderIndex: value.orderIndex ?? idx + 1,
					orderIndexSeq: value.orderIndexSeq ?? 0,
					usageDifference: value.childItemUsage - value.coordinateUsage,
				})
			));
			setOriginalMST3040_R01UsageList(responseData);
			setMessage(`${selectedMST3040_R01?.prntItemnm}의 BOM 좌표정보 대조 ${responseData.length}건을 조회하였습니다.`);
			setTimeout(() => setMessage(""), 5000);
		}else{
			setMST3040_R01UsageList([]);
			// showWarning('해당 모품목코드의 자품목 목록이 없습니다.');
			// 행추가 안함
			// insertMST3040_R01DetailList([{ ...defaultMST3040_R01DetailRow, orderIndex: responseData.length + 1, orderIndexSeq: 0, inserted: true }]);
		}
	}, [selectedMST3040_R01, MST3040_R01DetailList])
	
	const initContainerData = useCallback(() => {
		initData();
		removeDeletedMST3040_R01DetailList();
		removeSelectedMST3040_R01DetailList();
		setEditMST3040_R01({
			...defaultMST3040_R01HeaderDto,
		})
	}, [compCdList, selectedMST3040_R01])

	
	const handleInsertClick = useCallback((e: React.MouseEvent<HTMLButtonElement>) => {
		InsertRowHandler({
			event: e,
			dataList: MST3040_R01DetailList,
			rowData: {...defaultMST3040_R01DetailDto, valueIndex: -1},
			insertRow: insertMST3040_R01DetailList,
			defaultRowData: defaultMST3040_R01DetailDto,
			setClickable
		});
	}, [MST3040_R01List, insertMST3040_R01DetailList, setClickable]);

	const handleDeleteClick = useCallback(() => {

		if (deletedMST3040_R01DetailList.length > 0) {
			// 삭제 표시된 행이 있으면 전체 복구
			removeDeletedMST3040_R01DetailList(deletedMST3040_R01DetailList);
			removeSelectedMST3040_R01DetailList();
			setMST3040_R01DetailList([...MST3040_R01DetailList]);
		} else if (selectedMST3040_R01DetailList.length > 0) {
			addDeletedMST3040_R01DetailList(selectedMST3040_R01DetailList);
			removeSelectedMST3040_R01DetailList(selectedMST3040_R01DetailList);
		}
	}, [selectedMST3040_R01DetailList, 
		deletedMST3040_R01DetailList,
		addDeletedMST3040_R01DetailList,
		removeDeletedMST3040_R01DetailList,
		removeSelectedMST3040_R01DetailList,
		setMST3040_R01DetailList,
		MST3040_R01DetailList]);
	
	const handleCreateClick = () => {
		setSelectedMST3040_R01(undefined);
		setEditMST3040_R01({
			...defaultMST3040_R01HeaderDto
		})
		setMST3040_R01DetailList([{...defaultMST3040_R01DetailRow(), inserted: true}]);
		setDeletedMST3040_R01DetailList([]);
		setSelectedMST3040_R01DetailList([]);
		setOriginalMST3040_R01DetailList([]);
	}

	const validateInsertData = (header: MST3040_R01HeaderDto, detailDto: MST3040_R01DetailDto, ) => {

		if(!validateString(header.prntItemcd)) {
			showWarning('품목코드가 없습니다.');
			return false;
		}
		if(!itemCdMap.has(header.prntItemcd)) {
			showWarning('모품목코드가 해당 MES의 품목정보에 존재하지 않습니다.\n품목코드: ' + detailDto.prntItemcd); return false;
		}

		// 1. 필수 값 유효성 검사
		if(!validateString(detailDto.coordinateCd)) {
			showWarning('로케이션을 선택하세요.');
			return false;
		}
		if(!validateString(detailDto.coordinateNm)) {
			showWarning('로케이션명을 입력하세요.');
			return false;
		}
		if(!validateString(detailDto.topBottom)) {
			showWarning('상하Layer를 선택하세요.');
			return false;
		}
		if(detailDto.orient > 1080 && detailDto.orient < -1080) {
			showWarning('방향은 1080도 이하거나 -1080도 이상이으로 설정할수 없습니다.');
			return false;
		}
		if(!validateString(detailDto.childItemcd) || !validateString(detailDto.childItemnm)) {
			showWarning('자품목코드를 선택하세요.');
			return false;
		}
		if(!itemCdMap.has(detailDto.childItemcd)) {
			showWarning('자품목코드가 해당 MES의 품목정보에 존재하지 않습니다.\n품목코드: ' + detailDto.childItemcd); return false;
		}
		return true;
	}

	const handleSaveClick = useCallback(async () => {

		// 신규 사용자 처리
		const insertedList: MST3040_R01DetailDto[] = MST3040_R01DetailList.filter(row => 
			!deletedMST3040_R01DetailList.includes(row.valueIndex.toString()) && 
			row.inserted === true
		);

		const modifiedList : MST3040_R01DetailDto[] = MST3040_R01DetailList.filter(row => 
			!deletedMST3040_R01DetailList.includes(row.valueIndex.toString()) && 
			row.isModified && !row.inserted
		);
		
        // 수정 사용자 유효성 검증
		let seenMenuSet = new Set<string>();
		let valid = true;
		modifiedList.forEach((value) => {
			let index = MST3040_R01DetailList.findIndex(Order => Order.coordinateCd === value.coordinateCd);
			if(!validateInsertData(selectedMST3040_R01!, value)) valid = false;
			seenMenuSet.add(value.coordinateCd);
		});
		if(!valid) { return; }
        // 신규 사용자 유효성 검증
		seenMenuSet = new Set<string>();
		valid = true;
		insertedList.forEach((value) => {
			let index = MST3040_R01DetailList.findIndex(Order => Order.coordinateCd === value.coordinateCd);
			if(!validateInsertData(selectedMST3040_R01!, value)) valid = false;
			seenMenuSet.add(value.coordinateCd);
		});
		if(!valid) { return; }

		const deleteStringList = deletedMST3040_R01DetailList.map(item => item.toString());
		//마감여부가 Y인 작업지시는 삭제 불가
		const deleteTargetList = MST3040_R01DetailList.filter(item => 
			deleteStringList.includes(item.valueIndex.toString())
		);

		const [insertedResponse, modifiedResponse, deleteResponse] = await Promise.all([
			insertedList.length > 0 ? postMST3040_R01(insertedList) : Promise.resolve(),
			modifiedList.length > 0 ? patchMST3040_R01(modifiedList) : Promise.resolve(),
			deleteTargetList.length > 0 ? Promise.all(deleteTargetList.map(value =>  deleteMST3040_R01(value.coordinateCd) )) : Promise.resolve()
		]);

		if(insertedResponse?.data.successFlag || modifiedResponse?.data.successFlag) {
			showSuccess('작업지시정보 저장이 완료되었습니다.');
			setMessage('작업지시정보 저장이 완료되었습니다.');
			setTimeout(() => { setMessage(''); }, 5000);
		} else if(deleteResponse) {
			showSuccess('작업지시정보 삭제가 완료되었습니다.');
			setMessage('작업지시정보 삭제가 완료되었습니다.');
		}
		setTimeout(() => { setMessage(''); }, 5000);

		setMST3040_R01DetailList([]);
		setDeletedMST3040_R01DetailList([]);
		setSelectedMST3040_R01DetailList([]);
		setOriginalMST3040_R01DetailList([]);

		//Detail 조회 다시 실행
		if(selectedMST3040_R01) {
			fetchDetailList(selectedMST3040_R01.prntItemcd!);
		}

	}, [MST3040_R01DetailList, deletedMST3040_R01DetailList, originalMST3040_R01DetailList, selectedMST3040_R01]);

	// 상세/소요량 조회
	useEffect(() => {
		if (!detailFetchTrigger || !selectedMST3040_R01?.prntItemcd) return;
		fetchDetailList(selectedMST3040_R01.prntItemcd);
		fetchUsageList(selectedMST3040_R01.prntItemcd);
		setDetailFetchTrigger(false);
	}, [detailFetchTrigger, selectedMST3040_R01, fetchDetailList, fetchUsageList, setDetailFetchTrigger]);

	useEffect(() => {
		if (selectedMST3040_R01 && MST3040_R01DetailList.length === 0) {
			insertMST3040_R01DetailList([{ ...defaultMST3040_R01DetailRow(), inserted: true }]);
		}
	}, [selectedMST3040_R01, MST3040_R01DetailList])
	
	return {
		clickable, setClickable,
		handlePrintClick,
		handleExcelClick,
		fetchData,
		defaultMST3040_R01DetailRow,
		defaultMST3040_R01UsageRow,
		initContainerData,
		handleInsertClick,
		handleDeleteClick,
		handleCreateClick,
		handleSaveClick,
	};
}
